// Estado vazio da aba de Banners. Explica onde o banner aparece pro cliente
// antes de o dono cadastrar o primeiro — evita a tela em branco que nao
// informa nada. Substituido pela lista assim que houver banner cadastrado.

import { ImagePlus, Monitor, Smartphone } from "lucide-react";

export default function BannersEmptyState() {
  return (
    <div className="bg-card border border-border rounded-2xl p-8 md:p-12 flex flex-col items-center text-center">
      <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mb-4">
        <ImagePlus className="w-8 h-8 text-primary" strokeWidth={1.5} />
      </div>

      <h2 className="text-lg font-semibold tracking-tight">Nenhum banner cadastrado</h2>
      <p className="text-sm text-muted-foreground mt-1.5 max-w-md">
        Banners são as imagens de destaque que aparecem logo abaixo do cabeçalho
        do cardápio. Use para anunciar promoções, novidades e datas especiais.
      </p>

      <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
        <Canal icon={Monitor} label="Cardápio no computador" />
        <Canal icon={Smartphone} label="Cardápio no celular" />
      </div>
    </div>
  );
}

function Canal({ icon: Icon, label }) {
  return (
    <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-muted text-xs font-medium text-muted-foreground">
      <Icon className="w-3.5 h-3.5" strokeWidth={1.8} />
      {label}
    </span>
  );
}
